import { gql } from '@apollo/client';

export const DOCUMENT_CLAUSE_UPDATED = gql`
  subscription documentClauseUpdated {
    documentClauseUpdated {
      clause {
        clauseId
        clauseCode
        clauseText
        orderNo
        formula
        parentClauseId
        clauseTypeId
        documentTypeId
        validityDays
        mandatory
        enabled
      }
    }
  }
`;
